import { HTMLAttributes, ReactNode } from 'react';
import XMark from 'apps/cdp-web-demo/app/icons/xmark.svg';

import styles from './Card.module.css';

type Props = {
  heading?: ReactNode;
  onClose?: () => void;
};

function Card({
  children,
  heading,
  className = '',
  onClose,
  ...props
}: Props & HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`${styles.card} ${className}`} {...props}>
      {!!(onClose ?? heading) && (
        <div className={styles['heading-row']}>
          {!!heading && <h2 className={styles.heading}>{heading}</h2>}
          {!!onClose && (
            <button aria-label="Close" className={styles.close} onClick={onClose} type="button">
              <XMark aria-hidden="true" role="img" className={styles.icon} />
            </button>
          )}
        </div>
      )}
      {children}
    </div>
  );
}

export { Card };
